export default __webpack_public_path__ + "4734a4af0dbb405925b23b1cb93a137c.jpg";